<template>
  <div class="info-content">
    <div
        ref="section1"
        class="info-section overview"
    >
      <div class="section-title">
        <div class="title-row">
          <img
              :src="require('@/assets/images/officialWebsite/buleleft.png')"
              class="nucleus"
          />
          <div class="section-title__text">联系我们</div>
          <img
              :src="require('@/assets/images/officialWebsite/blueright.png')"
              class="nucleus"
          />
        </div>
        <p class="title-eng">contact us</p>
      </div>
      <div class="intro-item">
        <baidu-map :center="center" :zoom="zoom" class="bm-view" @ready="handler">
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
          <bm-geolocation :autoLocation="true" :showAddressBar="true"
                          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-geolocation>
          <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
          <bm-marker :dragging="true" :position="{lng: 113.4356101577, lat: 23.1704989226}"
                     animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
        </baidu-map>
      </div>
      <div
          v-for="(item, index) in contactList"
          :key="index"
          class="business-certified"
      >
        <img
            class="business-imgUrl"
            :src="item.imageUrl"
            alt=""
        />
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {
      contactList: [
        {
          imageUrl: require('@/assets/images/products/contactUs/contactUs1.png'),
          text: '020-31703435'
        },
        {
          imageUrl: require('@/assets/images/products/contactUs/contactUs2.png'),
          text: 'zs@zhishengtec.com'
        },
        {
          imageUrl: require('@/assets/images/products/contactUs/contactUs3.png'),
          text: '广州市黄埔区绿地中央场E栋2601-2603'
        }
      ],
      tabIndex: 6,
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 3
    }
  },
  methods: {
    handler ({
      BMap,
      map
    }) {
      this.center.lng = 113.4356101577 // 113.4356101577
      this.center.lat = 23.1704989226 // 23.1704989226
      this.zoom = 19
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>

<style lang="scss" scoped>
.info-content {
  .info-section {
    box-sizing: border-box;
    padding: 20px 0;

    &.overview {
      color: #333;
      padding: 15px;

      .business-certified {
        align-items: center;
        padding: 12px 20px;
        display: flex;
        background: #F6F9FB;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
      }


      .business-imgUrl {
        margin-right: 20px;
        width: 22px;
      }

      .intro-item {
        width: 100%;
        height: 350px;
        margin-bottom: 89px;

        .bm-view {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.section-title {
  margin: 0 auto;
  text-align: center;

  .title-row {
    display: flex;
    justify-content: center;
    align-items: center;

    .nucleus {
      height: 10px;
      margin: 0 10px;
    }

    .section-title__text {
      color: #383838;
      font-size: 22px;
    }
  }

  .title-eng {
    font-size: 12px;
    color: #999;
  }
}
</style>
